import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a470a3e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "poster",
  ref: "posterInfo"
};
const _hoisted_2 = {
  class: "inviter-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "img-box"
};
const _hoisted_6 = {
  class: "img-padding"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "长按识别二维码", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "icon",
    src: $props.cpInfo.icon
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString($props.cpInfo.nickname), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    class: "img",
    src: $props.shareInfo.qr_img
  }, null, 8, _hoisted_7)])]), _hoisted_8], 512);
}